module.exports = __webpack_public_path__ + "img/E2 Box.fc6d5cfa.png";